/* eslint-disable block-scoped-var */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */

import "phaser";
import { NormalEnemy, Enemy, BossEnemy, ChaserEnemy, EnemyFactor } from "./../Entities/Enemies"
import { getRandomInt } from "./../modules/utiltes"
export class EnemyHandler {
    constructor() {

    }
    static prepareEnemies() {
        let commonProperties = {
                level: 1,
                scaleX: 1,
                scaleY: 1,
                speedX: 0,
                speedY: Phaser.Math.Between(10, 30),
            }
            /////////////////////////////////////////////////
        this.enemies = [{
                name: "sprEnemy0",
                commonProperties: commonProperties,
                class: NormalEnemy

            },
            {
                name: "sprEnemy1",
                commonProperties: commonProperties,
                class: ChaserEnemy
            },
            {
                name: "sprEnemy3",
                commonProperties: commonProperties,
                class: Enemy
            },
            {
                name: "boss",
                commonProperties: commonProperties,
                class: BossEnemy
            }
        ]
        this.maxenemy = 4;
    }
    static getEnemies() {
        return this.enemies
    }
    static getMaxEnemies() {
        return this.maxenemy
    }

    static prepareEnemyshoots() {
        let commonProperties = {
                speedX: 0,
                speedY: 200,
            }
            //////////////////////////////////////////////////////////////////
        this.enemyshoots = [{
                name: "sprLaserEnemy0",
                commonProperties: commonProperties,
            },
            {
                name: "sprLaserEnemy0",
                commonProperties: commonProperties,
            },
            {
                name: "sprLaserEnemy0",
                commonProperties: commonProperties,
            },
            {
                name: "bossshoot",
                commonProperties: commonProperties,
            },
        ]
    }
    static getEnemyshoots() {
        return this.enemyshoots
    }
    static prepare() {
        this.prepareEnemies()
        this.prepareEnemyshoots()
    }
    static createEnemy(scene, enemies, enemyshoot, player) {
        let enemy = null;
        let enemyrandom;
        if (player.getCurrentPlayerScore() >= 20) {
            enemyrandom = getRandomInt(this.getMaxEnemies());
        } else {
            enemyrandom = getRandomInt(this.getMaxEnemies() - 1);
        }
        enemy = new EnemyFactor(
            scene,
            Phaser.Math.Between(0, scene.game.config.width),
            0,
            enemies[enemyrandom].name,
            "Enemy",
            enemies[enemyrandom].commonProperties.level,
            enemies[enemyrandom].commonProperties.scaleX,
            enemies[enemyrandom].commonProperties.scaleY,
            enemies[enemyrandom].commonProperties.speedX,
            enemies[enemyrandom].commonProperties.speedY,
            enemyshoot[enemyrandom].name,
            enemyshoot[enemyrandom].commonProperties.speedX,
            enemyshoot[enemyrandom].commonProperties.speedY
        );
        enemy = enemy.create(scene, Phaser.Math.Between(0, scene.game.config.width), 0, enemies[enemyrandom].name, "Enemy", enemies[enemyrandom].commonProperties.level, enemies[enemyrandom].commonProperties.scaleX, enemies[enemyrandom].commonProperties.scaleY, enemies[enemyrandom].commonProperties.speedX, enemies[enemyrandom].commonProperties.speedY, enemyshoot[enemyrandom].name, enemyshoot[enemyrandom].commonProperties.speedX, enemyshoot[enemyrandom].commonProperties.speedY, enemies[enemyrandom].class)
        enemy.applyEnemyAction()
        if (enemy !== null) {
            scene.enemies.add(enemy);
        }
        return enemy
    }
}